export default __webpack_public_path__ + "static/media/02_bociany.910d483d.png";